module.exports = __webpack_public_path__ + "static/media/qrcode.2d9cfd0b.png";